<template>
  <div class="g-leftlist">
    <div class="logo">
      <router-link to="/" >
        <div class="a">
          <img v-if="userInfo.companyLogo" :src="userInfo.companyLogo" alt=""/>
          <img v-else src="@/assets/images/logoNew.png" alt="" style="filter: grayscale(1);"/>
          <div class="txt">{{ userInfo.companyName || '请设置公司名称' }}</div>
        </div>
      </router-link>
    </div>
    <ul class="nav">
      <li :class="pos == 1 ? 'act' : ''">
        <div class="v1">
          <router-link to="/home-supplier" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a1.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a1-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">企业主页</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 2 ? 'act' : ''">
        <div class="v1">
          <router-link to="/suppliercenter-information" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a2.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a2-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">账号资料</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 3 ? 'act' : ''">
        <div class="v1">
          <router-link to="/supplier-equity" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a3.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a3-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">我的会员</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 4 ? 'act' : ''">
        <div class="v1">
          <router-link to="/suppliercenter-bookmanagement" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a4.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a4-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">在线选书</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 5 ? 'act' : ''">
        <div class="v1">
          <router-link to="/suppliercenter-library" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a5.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a5-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">图书库</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 6 ? 'act' : ''">
        <div class="v1">
          <router-link to="/suppliercenter-submittedorder" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a6.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a6-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">订单管理</div>
          </router-link>
        </div>
      </li>
<!--      <li :class="pos == 10 ? 'act' : ''">-->
<!--        <div class="v1">-->
<!--          <router-link to="/order-list" class="t">-->
<!--            <div class="icon">-->
<!--              <img src="@/assets/images/f-a12.png" class="img img1" alt="" />-->
<!--              <img src="@/assets/images/f-a12-1.png" class="img img2" alt="" />-->
<!--            </div>-->
<!--            <div class="txt">已提交订单</div>-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </li>-->
      <li :class="pos == 7 ? 'act' : ''">
        <div class="v1">
          <router-link to="/common-myattention" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a7.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a7-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">我的关注</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 8 ? 'act' : ''">
        <div class="v1">
          <router-link to="/common-messagecenter" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a8.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a8-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">消息中心</div>
          </router-link>
        </div>
      </li>
      <li :class="pos == 9 ? 'act' : ''">
        <div class="v1">
          <router-link to="/download-center" class="t">
            <div class="icon">
              <img src="@/assets/images/f-a11.png" class="img img1" alt="" />
              <img src="@/assets/images/f-a11-1.png" class="img img2" alt="" />
            </div>
            <div class="txt">下载中心</div>
          </router-link>
        </div>
      </li>
    </ul>
    <div class="lt-box">
      <div class="inner">
        <div class="img"><img src="@/assets/images/logo2.png" alt="" /></div>
        <div class="txt">图书查单服务平台</div>
        <div class="telbox">
          <div class="icon"><img src="@/assets/images/f-tel.png" alt="" /></div>
          <div class="right">
            <div class="p">010-3678 6688</div>
            <div class="p">工作日 9:00 - 18:00</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lt-copy">
      <div class="links">
        <div class="li">
          <a
            href="/home/index/protocol/type/bk_user_protocol.html"
            target="_blank"
            class="a"
            >用户协议</a
          >
        </div>
        <div class="li">
          <a
            href="/home/index/protocol/type/bk_privacy_protocol.html"
            target="_blank"
            class="a"
            >隐私政策</a
          >
        </div>
        <div class="li">
          <a
            href="/home/index/protocol/type/bk_author_protocol.html"
            target="_blank"
            class="a"
            >隐私政策</a
          >
        </div>
      </div>
      <div class="copy">
        版权所有 Copyright ©
        <router-link to="/" class="a">{{
          commonConfig.bk_config_copyright
        }}</router-link>
        <a href="https://beian.miit.gov.cn/" class="a" target="_blank">
          {{ commonConfig.bk_config_beian }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pos"],
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
  }
};
</script>
<style scoped>
.g-leftlist {
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 345px;
  background: #ffffff;
  box-shadow: 13px 3px 46px 0px rgba(0, 0, 0, 0.02);
  padding: 20px 0 0;
  z-index: 99;
}
.g-leftlist .logo {
  margin-bottom: 20px;
  padding-left: 56px;
}
.g-leftlist .logo .a{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;

}
.g-leftlist .logo img {
  display: block;
  width: 62px;
  margin-right: 8px;
}
.nav .t {
  display: block;
  height: 66px;
  display: flex;
  align-items: center;
  padding-left: 56px;
  position: relative;
  font-size: 16px;
  transition: 0.3s;
}
.nav {
  margin-bottom: 30px;
}
.nav li {
  height: 60px;
}
.nav .t:hover {
  color: #1690ff;
}
.nav .act .t {
  background-color: #ebf3ff;
  color: #1690ff;
}
.nav .t::after {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 9px;
  height: 100%;
  background: #1690ff;
  border-radius: 4px 5px 5px 4px;
  content: "";
  opacity: 0;
}
.nav .act .t::after {
  opacity: 1;
}
.nav .icon {
  margin-right: 22px;
  width: 26px;
}
.nav .icon img {
  display: block;
  /* width: 28px; */
  /* max-width: 28px;
  max-height: 30px; */
  width: 100%;
}
.nav .txt{
  flex: 1;
}
.nav .icon .img2 {
  display: none;
}
.nav .act .icon .img2 {
  display: block;
}
.nav .act .icon .img1 {
  display: none;
}
.lt-box {
  width: 235px;
  height: 161px;
  background: #1690ff;
  border-radius: 4px;
  margin: 0 auto;
  padding: 18px 30px;
  color: #fff;
  position: relative;
}
.lt-box::after {
  position: absolute;
  left: 12px;
  top: 12px;
  width: 40px;
  height: 24px;
  background: #1690ff;
  border-radius: 4px 5px 5px 4px;
  content: "";
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(@/assets/images/f-bg.png);
}
.lt-box .inner {
  position: relative;
  z-index: 1;
}
.lt-box .img {
  margin-bottom: 4px;
}
.lt-box .img img {
  display: block;
  width: 133px;
}
.lt-box .txt {
  font-size: 15px;
  margin-bottom: 15px;
}
.lt-box .telbox {
  display: flex;
  align-items: center;
  font-size: 12px;
}
.lt-box .telbox .icon {
  width: 31px;
}
.lt-box .telbox .icon img {
  display: block;
  width: 100%;
}
.lt-copy {
  font-size: 12px;
  padding: 0 56px;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
}
.lt-copy .links {
  margin-bottom: 4px;
}
.lt-copy .links .li {
  display: inline-block;
  color: #6f7680;
  transition: 0.3s;
  padding-right: 10px;
  margin-right: 10px;
  position: relative;
}
.lt-copy .links .li::after {
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 11px;
  background-color: #e5e8ef;
  content: "";
}
.lt-copy .links a {
  color: #6f7680;
  transition: 0.3s;
}
.lt-copy .links a:hover {
  color: #000;
}
.lt-copy .copy {
  color: #9fa6af;
}
.lt-copy .copy a {
  color: inherit;
  transition: 0.3s;
}
.lt-copy .copy a:hover {
  color: #000;
}
</style>
